export default function WeeklyProgressAll({
  weeks = [ // 최근 8주 중앙값 EV%
    { label: 'W1', medEV: 12 }, { label: 'W2', medEV: 18 }, { label: 'W3', medEV: 23 },
    { label: 'W4', medEV: 31 }, { label: 'W5', medEV: 38 }, { label: 'W6', medEV: 44 },
    { label: 'W7', medEV: 49 }, { label: 'W8', medEV: 55 },
  ],
  deltaEVThisWeek = 1.6,   // 이번 주 중앙값 EV 상승폭(Δ)
  confirmsLastWeek = 124,  // 지난주 Confirm 건수 총합
  stalledProjects = 3,     // 2주 연속 ΔEV=0 프로젝트 수
}: {
  weeks?: {label:string; medEV:number}[];
  deltaEVThisWeek?: number;
  confirmsLastWeek?: number;
  stalledProjects?: number;
}) {
  const W = 360, H = 120, L=28, R=8, T=8, B=20;
  const iw = W - L - R, ih = H - T - B;
  const x = (i:number)=> L + (i*iw)/Math.max(1,weeks.length-1);
  const y = (v:number)=> T + ih - (Math.max(0,Math.min(100,v))*ih/100);
  const d = weeks.map((p,i)=>`${i?'L':'M'}${x(i)},${y(p.medEV)}`).join(' ');
  return (
    <div className="rounded-2xl border bg-white p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-medium">Weekly Progress</h2>
        <div className="flex gap-2 text-xs">
          <span className="px-2 py-0.5 rounded bg-emerald-100 text-emerald-800">ΔEV {deltaEVThisWeek.toFixed(1)}%</span>
          <span className="px-2 py-0.5 rounded bg-gray-100 text-gray-700">Confirm {confirmsLastWeek}</span>
          <span className="px-2 py-0.5 rounded bg-rose-100 text-rose-800">Stalled {stalledProjects}</span>
        </div>
      </div>
      <div className="mt-3 h-48">
        <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="none">
          {/* grid */}
          {[0,25,50,75,100].map(v=>(
            <g key={v}>
              <line x1={L} x2={W-R} y1={y(v)} y2={y(v)} className="stroke-gray-200" strokeDasharray="3 3"/>
              <text x={L-6} y={y(v)} textAnchor="end" dominantBaseline="middle" className="fill-gray-400 text-[10px]">{v}%</text>
            </g>
          ))}
          {/* axis */}
          <line x1={L} x2={W-R} y1={y(0)} y2={y(0)} className="stroke-gray-400"/>
          {/* line */}
          <path d={d} className="stroke-blue-600" fill="none" strokeWidth={2}/>
          {/* points */}
          {weeks.map((p,i)=>(
            <circle key={i} cx={x(i)} cy={y(p.medEV)} r={2.5} className="fill-blue-600"/>
          ))}
          {/* x labels */}
          {weeks.map((p,i)=>(
            <text key={p.label} x={x(i)} y={H-4} textAnchor="middle" className="fill-gray-500 text-[10px]">{p.label}</text>
          ))}
        </svg>
      </div>
    </div>
  );
}
